import { Button } from '@reckon-web/button';
import { Flex } from '@reckon-web/flex';
import { Heading } from '@reckon-web/heading';

export const Dialog: React.FC<{
  title: string;
  cancelLabel?: string;
  onCancel?: () => void;
  submitLabel?: string;
  onSubmit: () => void;
  submitTone?: 'active' | 'critical';
  children?: React.ReactNode;
}> = ({
  children,
  title,
  cancelLabel = 'Cancel',
  onCancel,
  submitLabel = 'OK',
  onSubmit,
  submitTone = 'active',
}) => (
  <Flex direction="column" gap="large" padding="xlarge">
    <Heading level="4">{title}</Heading>
    {children}
    <Flex gap="small" justifyContent="flex-end">
      {onCancel && (
        <Button
          label={cancelLabel}
          weight="none"
          tone="passive"
          size="small"
          onClick={() => onCancel()}
        />
      )}
      <Button
        label={submitLabel}
        onClick={() => onSubmit()}
        tone={submitTone}
        size="small"
      />
    </Flex>
  </Flex>
);
